import React from "react";
import { Link } from "react-router-dom";

const PaymentSuccess = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-green-50 px-4">
      <div className="bg-white rounded-xl shadow-lg p-8 max-w-md text-center">
        <div className="text-5xl mb-4">  <span role="img" aria-label="payment success">✅</span></div>

        <h1 className="text-2xl font-bold text-green-700 mb-2">
          Payment Successful!
        </h1>

        <p className="text-gray-600 mb-6">
          Thank you for your order. Your payment has been processed
          successfully.
        </p>

        <div className="flex flex-col gap-3">
          <Link
            to="/dashboard"
            className="bg-green-600 text-white py-2 rounded-lg hover:bg-green-700 transition"
          >
            View My Orders
          </Link>

          <Link
            to="/"
            className="border border-green-600 text-green-600 py-2 rounded-lg hover:bg-green-50 transition"
          >
            Continue Shopping
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
